<template>
  <div class="form-container">
    <!-- モーダル画面 -->
    <ModalEditScenarioDemo/>
    <ModalDeleteScenarioDemo/>
    <ModalDeleteNodeDemo/>
    <ContextMenuScenarioDemo/>
    <b-modal width="680px" :active.sync="iconSelectFlg">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title title" style="font-size: 24px;">
            アイコンの種類を選択してください。
          </p>
        </header>
        <div class="card-content" style="height: 500px;">
          <div style="display: flex; justify-content: space-around; align-items: center; flex-wrap: wrap;">
            <button
              @click="template=i;iconSelectFlg=false"
              class="button"
              style="border-radius: 0; height: 50px; width: 50px; border-radius: 50%;"
              v-for="(i, index) in 9"
              :style="makeIconSelect()"
              :value="index"
              :key="index">
              <span :class="getIcon(i)"></span>
            </button>
          </div>
          <div style="width: 100%; height: 250px; display:flex; justify-content: center; align-items:center; flex-direction: column;">
            <div style="width: 130px; height: 130px; background: white; border: dashed thin #323;">
              <b-tooltip label="クリックもしくはドラッグ＆ドロップで画像をアップロードします。">
                <croppa
                  v-model="croppa" 
                  placeholder="画像のアップロードする"
                  canvas-color="transparent"
                  :width="128"
                  :height="128"
                  :file-size-limit="2097152"
                  remove-button-color="black"
                  accept=".jpeg,.png,.gif,.svg,.bmp,.jpg"
                  :show-loading="true"
                  @file-type-mismatch="onFileTypeMismatch"
                  @file-size-exceed="onFileSizeExceed">
                </croppa>
              </b-tooltip>
            </div>
            <a class="button button-img" style="margin-top:5px;" @click="croppa.chooseFile()">
              <span class="mdi mdi-image" style="margin-right: 10px;"></span>画像のアップロードする
            </a>
          </div>
          <hr>
          <button class="button is-primary is-fullwidth" @click="saveImage(croppa.generateDataUrl());iconSelectFlg=false" :disabled="croppa == null">
            画像の保存
          </button>
        </div>
      </div>
    </b-modal>
    <!-- 本文 -->
    <div class="header-box">
      <h2 class="catch-copy">
        <img style="height: 64px;" src="@/assets/logo.svg">{{title}}
      </h2>
      <div class="detail">
        <p>{{detail[0]}}</p>
        <p>{{detail[1]}}</p>
      </div>
    </div>
    <div class="demo-box">
      <div class="demo-action-box">
        <input class="input input-url" v-model="url" placeholder="設置をご検討中のURLを入力"/>
        <button @click="setLog();$store.dispatch('auth/demoImage', {url: url, is_mobile: isMobile()})" style="width:50px; color: #1B2C61; border-radius: 0; background: #dee1e7;" class="button is-primary">→</button>
        <p class="color-title">カラー</p><input class="input input-color" v-model="color" type="color"/>
        <button class="button color-type" style="color: #1B2C61; border-radius: 0; background: #dee1e7;" @click="iconSelectFlg=true">種類 →</button>
      </div>
      <div class="demo-image-box">
        <div class="demo-footer" v-if="!isGetImage && !isDemoLoading && !isInitNav">
          <div class="demo-footer-caption">
            <p>ナビゲーションに従いますと<br/>無料登録が可能です。是非お試し下さい。</p>
            <button @click="isInitNav=true" style="color: white; font-size: 30px; font-weight: 800; position: absolute; right: 0; top: 0; background: rgba(0,0,0,0); border: none; cursor: pointer;">×</button>
          </div>
        </div>
        <div class="demo-footer" v-if="isGetImage">
          <div class="demo-footer-caption">
            <p v-if="pages == 1">アイコンが表示されます。アイコンは自由に変更可能です。<br/>（スライダーで自由に位置を調整してみてください）</p>
            <p v-if="pages == 2">設定したロボが表示されます。（表現を変えることも可能です。）</p>
            <p style="white-space: pre-wrap;" v-if="pages == 3">チャット画面ではシナリオに応じて、ロボと会話できます。</p>
            <p style="white-space: pre-wrap;" v-if="pages == 4">ロボもお創りいただけます。試してみませんか？</p>
          </div>
          <nav class="demo-footer-nav">
            <a class="nav-button" :class="{'step-01': pages == 1}" @click="pages=1"></a>
            <a class="nav-button" :class="{'step-02': pages == 2}" @click="pages=2"></a>
            <a class="nav-button" :class="{'step-03': pages == 3}" @click="pages=3"></a>
            <a class="nav-button" :class="{'step-04': pages == 4}" @click="pages=4" v-if="isMobile() == false"></a>
          </nav>
        </div>
        <button class="prev-button" @click="prev" v-if="isMobile() == false && isGetImage && pages != 4"><img class="arrow-reverse" src="@/assets/lp/arrow.svg"/></button>
        <input type="range" max="70" class="slider-x" v-model="x" v-if="pages == 1 && isGetImage"/>
        <input type="range" max="70" class="slider-y" v-model="y" v-if="pages == 1 && isGetImage"/>
        <progress class="progress loop is-small" max="100" v-if="isDemoLoading">5%</progress>
        <img class="demo-image" v-touch:swipe.right="prev" v-touch:swipe.left="next" :src="getURL()" v-if="!isDemoLoading"/>
        <div class="demo-image-loading" v-if="isDemoLoading">
          <Loading/>
        </div>
        <transition name="slide">
          <div class="page-01" :style="makeIcon()" v-if="pages == 1 && isGetImage && !originalImage">
            <span :class="classObj"></span>
          </div>
          <div class="page-01" :style="makeIcon()" v-else-if="pages == 1 && isGetImage">
            <img style="border-radius: 50%;" :src="originalImage">
          </div>
        </transition>
        <transition name="slide">
          <div class="page-02" v-touch:swipe.right="prev" v-touch:swipe.left="next" v-if="pages == 2 && isGetImage">
            <div class="page-02-header" :style="makeBackground()"><p>〇〇株式会社</p></div>
            <div class="page-02-body" style="position: relative;">
              <img class="bot-image" :src="originalImage" v-if="originalImage"/>
              <img src="@/assets/lp/lp_example_02.png" v-if="isMobile() == false"/>
              <img src="@/assets/lp/lp_example_02_m.png" v-else/>
            </div>
          </div>
        </transition>
        <transition name="slide">
          <div class="page-03" v-touch:swipe.right="prev" v-touch:swipe.left="next" v-if="pages == 3 && isGetImage">
            <div class="page-03-header" :style="makeBackground()"><p>〇〇ロボ</p></div>
            <div class="page-03-body">
              <div style="width: 100%; height: 100%; display: flex; justify-content: flex-start; padding: 5px; flex-direction: column;">
                <div style="width: 100%; display: flex; justify-content: space-around; margin-top: 10px;">
                <img style="width: 40px; height: 40px; border-radius: 50%; border: solid thin #ccc;" src="@/assets/template/robot.png" v-if="!originalImage"/>
                <img style="width: 40px; height: 40px; border-radius: 50%; border: solid thin #ccc;" :src="originalImage" v-if="originalImage"/>
                <div style="width: 70%;  height: auto; background: #F3F3F3; border-radius: 10px; border-top-left-radius: 0; font-size: 10px; text-align: left; padding: 5px; border: solid thin #ccc;">
                  こんにちはホームページへようこそ！見ていただき、ありがとうございます。
                </div>
                </div>
                <div style="width: 100%; display: flex; justify-content: space-around; margin-top: 10px;">
                <img style="width: 40px; height: 40px; border-radius: 50%; border: solid thin #ccc;" src="@/assets/template/robot.png" v-if="!originalImage"/>
                <img style="width: 40px; height: 40px; border-radius: 50%; border: solid thin #ccc;" :src="originalImage" v-if="originalImage"/>
                <div style="width: 70%;  height: auto; background: #F3F3F3; border-radius: 10px; border-top-left-radius: 0; font-size: 10px; text-align: left; padding: 5px; border: solid thin #ccc;">
                  何かお探しですか？
                  <button class="button" style="font-size: 10px; margin: 2.5px;">会社概要について</button>
                  <button class="button" style="font-size: 10px; margin: 2.5px;">応募について</button>
                  <button class="button" style="font-size: 10px; margin: 2.5px;">社風について</button>
                </div>
                </div>
              </div>
              <!-- <img src="@/assets/lp/lp_example_03.png" v-if="isMobile() == false"/>
              <img src="@/assets/lp/lp_example_03_m.png" v-else/> -->
            </div>
          </div>
        </transition>
        <transition name="slide">
          <div class="page-04" v-if="pages == 4 && isGetImage">
            <button @click="pages=1" style="position: absolute; bottom: 15px; right: 15px; width: 48px; height: 48px; border-radius: 50%; box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3); color: #1B2C61; background: white; cursor: pointer; z-index: 10;"><span class="mdi mdi-home mdi-24px"></span></button>
            <div class="bot-create-01" v-if="createPages==0">
              <p class="make-title">ロボも創ってみませんか？</p>
              <p class="make-title">こちらからお試しできます。</p>
              <button class="make-bot-button" @click="createPages=1">
                創ってみる
              </button>
            </div>
            <div class="bot-create-01" v-if="createPages==1">
              <p class="make-title">ロボのタイプをストアから選んでみましょう。</p>
              <p class="make-title">無料でお選びできます。</p>
              <div style="height: 70%; width: 95%; display: flex; justify-content: center; align-items: center; flex-wrap: wrap;">
                <div class="make-bot-button bot-type" @click="getScenario('demo_00');createPages=2" style="">
                  <img style="width: 100px; height: 100px; object-fit: scale-down; border-radius: 15px; background: white; margin: 5px;" src="@/assets/lp/bot0.png"/>
                  <div>
                    <p>応募ロボタイプ</p>
                    <p style="color: #999;">editor's choice</p>
                    <star-rating :rating="5" :read-only="true" style="font-size: 12px; margin-top: 0; color: #666;" :rounded-corners="true" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :increment="0.5" :star-size="30" :show-rating="false"></star-rating>
                  </div>
                </div>
                <div class="make-bot-button bot-type" @click="getScenario('demo_01');createPages=2">
                  <img style="width: 100px; height: 100px; object-fit: scale-down; border-radius: 15px; background: white; margin: 5px;" src="@/assets/lp/bot1.png"/>
                  <div>
                    <p>FAQロボタイプ</p>
                    <p style="color: #999;">editor's choice</p>
                    <star-rating :rating="5" :read-only="true" style="font-size: 12px; margin-top: 0; color: #666;" :rounded-corners="true" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :increment="0.5" :star-size="30" :show-rating="false"></star-rating>
                  </div>
                </div>
              </div>
            </div>
            <div class="bot-create-01" v-if="createPages==2">
              <p class="make-title">会話シナリオを実際に創ってみましょう！</p>
              <div class="scenario-box">
                <div class="demo-guide-view" v-if="guide==0">
                  <p style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center;">{{messages[0]}}</p>
                  <button @click="nextScn()" class="button is-primary" style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center; z-index: 5;">次へ進む</button>
                </div>
                <div class="demo-guide-view" v-if="guide==2">
                  <p style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center;">{{messages[1]}}</p>
                  <button @click="nextScn()" class="button is-primary" style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center; z-index: 5;">次へ進む</button>
                </div>
                <div class="demo-guide-view" v-if="guide==4">
                  <p style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center;">{{messages[2]}}</p>
                  <button @click="nextScn()" class="button is-primary" style="font-size: 18px; font-weight: 700; white-space: pre-wrap; display: flex; justify-content: center; align-items: center; z-index: 5;">次へ進む</button>
                </div>
                <div class="scenario-editor" style="background-color: #f9f9f9;" :class="{'on-drop-area': isDrop}" @dragover="onDragover" @drop.prevent="onDrop" @click.prevent="changeForm(false)" v-if="!isFailedScenario">
                  <div class="drop-filter" v-if="isDrop"></div>
                  <BluePrintDemo ref="bp"></BluePrintDemo>
                </div>
                <div class="insert-parts-area" style="overflow: hidden; position: relative;">
                  <div style="height: 33%; width: 100%; border: solid thin #ccc;" draggable="true" v-for="index in [1, 2, 3]" :key="index" @dragstart="dragScenarioParts(index)" @dragend="resetDrag()">
                    <p style="padding: 5px; font-size: 12px;" v-if="index === 1">選択肢ありメッセージ</p>
                    <img style="height: 70%;" src="@/assets/template/select_message.svg" draggable="false" v-if="index === 1">
                    <p style="padding: 5px; font-size: 12px;" v-if="index === 2">メッセージのみ</p>
                    <img style="height: 70%;" src="@/assets/template/single_comment.png" draggable="false" v-if="index === 2">
                    <p style="padding: 5px; font-size: 12px;" v-if="index === 3">応募フォーム</p>
                    <img style="height: 70%;" src="@/assets/template/subscript.png"      draggable="false" v-if="index === 3">
                  </div>
                  <transition name="slide-top">
                    <div style="background: #323; height: 100%; width: 100%; position: absolute; z-index: 3; display:flex; align-items: center;" v-if="guide!=5">
                      <img src="@/assets/lp/whitemonster.png" style="width: 100%;"/>
                    </div>
                  </transition>
                </div>
              </div>
              <div style="display: flex; justify-content: center; width: 90%;">
                <button class="button" @click="prevScn()" style="width: 50%; border: none; border-radius: 0; background: #1B2C61; color: white; font-weight: 800;" :disabled="guide==0">←　前へ戻る</button>
                <button class="button" @click="nextScn()" style="width: 50%; border: none; border-radius: 0; background: #1B2C61; color: white; font-weight: 800;" :disabled="guide==6">次へ進む　→</button>
              </div>
            </div>
            <div class="bot-create-01" v-if="createPages==3">
              <p class="make-title" style="width: 90%;">{{madeMessage}}</p>
              <div style="height: 70%; width: 80%; display: flex; justify-content: center; align-items: center; flex-wrap: wrap;">
                <a @click="saveScenarioAndMove()" class="make-bot-button" style="margin: 10px;">
                  無料トライアルを申し込む
                </a>
                <a @click="createPages = 2; guide = 5" class="make-bot-button" style="margin: 10px;">
                  作成したロボを修正する
                </a>
              </div>
            </div>
          </div>
        </transition>
        <button class="next-button" @click="next" v-if="isMobile() == false && isGetImage && pages != 4"><img class="arrow" src="@/assets/lp/arrow.svg"/></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
import Loading from '@/components/animations/Loading'
import BluePrintDemo from '@/views/Top/BluePrintDemo'
import ModalEditScenarioDemo from '@/views/Top/ModalEditScenarioDemo'
import ModalDeleteScenarioDemo from '@/views/Top/ModalDeleteScenarioDemo'
import ModalDeleteNodeDemo from '@/views/Top/ModalDeleteNodeDemo'
import ContextMenuScenarioDemo from '@/views/Top/ContextMenuScenarioDemo'
import randomString from '@/functions/randomString'
import getParam from '@/functions/getParam'
import createUUID from '@/functions/createUUID'
import StarRating from 'vue-star-rating'
export default {
  name: 'CompanyDemo',
  componentName: 'CompanyDemo',
  components: {
    Loading,
    BluePrintDemo,
    ModalEditScenarioDemo,
    ModalDeleteScenarioDemo,
    ContextMenuScenarioDemo,
    ModalDeleteNodeDemo,
    StarRating
  },
  data () {
    return {
      title: '設置イメージ',
      detail: [
        '下の枠内にHRモンスターを設置したいHPの\nURLをご入力ください。',
        'ロボ設置のイメージをご覧いただけます。'
      ],
      url: null,
      getImage: null,
      pages: 1,
      x: 1,
      y: 1,
      color: '#1B2C61',
      template: 0,
      iconSelectFlg: false,
      croppa: null,
      originalImage: null,
      createPages: 0,
      isInput: false,
      guide: 0,
      isInitNav: false,
      madeMessage: '今回はサンプルでしたが、色々なテンプレートをご用意しております。\n今、無料トライアルにお申し込みすると今回作成したロボをそのまま使用できます！',
      messages: [
        '会社名（もしくは事務所名）を入れてみましょう！\nパーツをダブルクリックすると編集ができます。',
        '次にメッセージを修正してみましょう！\n「男女比はX：Yです」などの文言を入れることで、求職者が聞きたい情報にリーチできます。',
        '最後にパーツを挿入してみましょう！ドラッグ＆ドロップを活用します。\n様々なパーツを組み合わせることで、ロボが出来上がります。\nパーツを入れた後はパーツ同士を線でつないでみましょう。'
      ]
    }
  },
  computed: {
    ...mapState('auth', ['demoImage', 'isGetImage', 'isDemoLoading']),
    ...mapState('chatbot', ['scenarioTable', 'scenarioName', 'isSCNLoading', 'isDrop', 'isFailedScenario', 'selectScenario', 'scenarioPartsIndex']),
    classObj () {
      return {
        'mdi mdi-message-reply mdi-48px': this.template === 0,
        'mdi mdi-account-location mdi-48px': this.template === 1,
        'mdi mdi-phone mdi-48px': this.template === 2,
        'mdi mdi-home-circle mdi-48px': this.template === 3,
        'mdi mdi-bell mdi-48px': this.template === 4,
        'mdi mdi-forum mdi-48px': this.template === 5,
        'mdi mdi-forum-outline mdi-48px': this.template === 6,
        'mdi mdi-comment mdi-48px': this.template === 7,
        'mdi mdi-comment-multiple mdi-48px': this.template === 8,
        'mdi mdi-comment-processing mdi-48px': this.template === 9
      }
    }
  },
  methods: {
    setLog () {
      console.debug('*** Start *** setLog')
      var ref = getParam('ref') ? getParam('ref') : ''
      var ua = navigator.userAgent.toLowerCase()
      var re = document.referrer
      var uuid = localStorage.getItem('__top_id')
      if (uuid == null) {
        console.debug('UUID is null')
        uuid = createUUID()
        localStorage.setItem('__top_id', uuid)
      }
      var phase = 1
      this.$store.dispatch('auth/createTopLPUser', {
        q_param_01: ref,
        useragent: ua,
        referer: re,
        uuid: uuid,
        phase: phase,
        url: this.url
      })
      console.debug('*** End *** setLog')
    },
    saveScenarioAndMove () {
      console.debug('*** Start *** saveScenarioAndMove')
      localStorage.setItem('_init_scenario', JSON.stringify(this.scenarioTable))
      this.$router.push('/create_client')
      console.debug('*** End *** saveScenarioAndMove')
    },
    autoCreateNode () {
      console.debug('*** Start *** autoCreateNode')
      var node = randomString(2)
      for (var i in this.scenarioTable) {
        if (this.scenarioTable[i].beforenode === node) node = ''
      }
      for (var j in this.autoCreate) {
        if (this.autoCreate[j] === node) node = ''
      }
      console.debug('node: ' + node)
      console.debug('*** End *** autoCreateNode')
      return node
    },
    createScenario (x, y) {
      console.debug('*** Start *** createScenario')
      console.debug('x: ' + JSON.stringify(x))
      console.debug('y: ' + JSON.stringify(y))
      var node = ''
      while (node === '') {
        node = this.autoCreateNode()
      }
      console.log('created: ' + JSON.stringify(node))
      var createTemplate = {
        name: this.scenarioTable[0].name,
        mainmessage: 'メッセージを記入して下さい',
        beforenode: node,
        beforenodeX: x,
        beforenodeY: y,
        select: [],
        status: 0,
        template: '',
        image: '',
        start_flg: false,
        is_edit: true
      }
      var select1 = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      var select2 = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      var select3 = {
        msg_type: '',
        message: '',
        text_option: '',
        next_node: '',
        point: '0',
      }
      // 選択肢付メッセージ
      if (this.scenarioPartsIndex === 1) {
        select1.msg_type = 'button'
        select1.text_option = 'white'
        select1.message = '選択肢1を入力'
        select2.msg_type = 'button'
        select2.text_option = 'white'
        select2.message = '選択肢2を入力'
        createTemplate.select.push(select1)
        createTemplate.select.push(select2)
      } else if (this.scenarioPartsIndex === 2) {
        createTemplate.select.push(select1)
        createTemplate.status = 2
      } else if (this.scenarioPartsIndex === 3) {
        createTemplate.select.push(select1)
        createTemplate.mainmessage = '[cv][/cv]'
        createTemplate.status = 1
      } else {
        // シナリオ以外のドロップは無視
        return 0
      }
      this.$store.dispatch('chatbot/saveScenarioDemo', createTemplate)
      console.debug('*** End *** createScenario')
    },
    dragScenarioParts (i, event) {
      console.debug('*** Start *** dragScenarioParts')
      console.debug('i: ' + JSON.stringify(i))
      console.debug('event: ' + JSON.stringify(event))
      console.log('Template is ' + i + ', ' + JSON.stringify(this.scenarioTable[0]))
      this.$store.dispatch('chatbot/changeIsDrop', i)
      console.debug('*** End *** dragScenarioParts')
    },
    resetDrag () {
      console.debug('*** Start *** resetDrag')
      this.$store.dispatch('chatbot/changeIsDrop', -1)
      console.debug('*** End *** resetDrag')
    },
    onDrop (event) {
      console.debug('*** Start *** onDrop')
      console.debug('event: ' + JSON.stringify(event))
      if (this.scenarioPartsIndex > 0) {
        var x = Math.round(event.offsetX * this.$refs.bp.ratio + this.$refs.bp.dx)
        var y = Math.round(event.offsetY * this.$refs.bp.ratio + this.$refs.bp.dy)
        if (x < 0) x = 0
        if (y < 0) y = 0
        this.createScenario(x, y)
        event.preventDefault()
        this.$store.dispatch('chatbot/changeIsDrop', -1)
      }
      console.debug('*** End *** onDrop')
    },
    onDragover (event) {
      console.debug('*** Start *** onDragover')
      console.debug('event: ' + JSON.stringify(event))
      event.preventDefault()
      console.debug('*** End *** onDragover')
    },
    changeForm (flg) {
      console.debug('*** Start *** changeForm')
      console.debug('flg: ' + JSON.stringify(flg))
      this.isInput = flg
      console.debug('*** End *** changeForm')
    },
    getScenario (type) {
      console.debug('*** Start *** getScenario')
      console.debug('type: ' + JSON.stringify(type))
      this.$store.dispatch('chatbot/getScenarioDemo', type)
      console.debug('*** End *** getScenario')
    },
    saveImage (image) {
      console.debug('*** Start *** saveImage')
      console.debug('image: ' + JSON.stringify(image))
      this.originalImage = image
      console.debug('*** End *** saveImage')
    },
    onFileTypeMismatch (file) {
      console.debug('*** Start *** onFileTypeMismatch')
      console.debug('file: ' + JSON.stringify(file))
      alert('jpg, gif, png, svg　形式でアップして下さい。')
      console.debug('*** End *** onFileTypeMismatch')
    },
    onFileSizeExceed (file) {
      console.debug('*** Start *** onFileSizeExceed')
      console.debug('file: ' + JSON.stringify(file))
      alert('ファイルは2MB以下でアップロードして下さい。')
      console.debug('*** End *** onFileSizeExceed')
    },
    isMobile () {
      if (window.innerWidth < 700) return true
      else return false
    },
    autoColor (c) {
//      console.debug('*** Start *** autoColor')
//      console.debug('c: ' + JSON.stringify(c))
      var color = hex2rgb(c)
      var cl = '#000'
      if ((color[0] * 0.299 + color[1] * 0.587 + color[2] * 0.114) < 206) cl = '#FFF'
//      console.debug('cl: ' + cl)
//      console.debug('*** End *** autoColor')
      return cl
    },
    makeIcon () {
      console.debug('*** Start *** makeIcon')
      return {
        bottom: 'calc(' + this.y + '% + ' + '5%)',
        right: 'calc(' + this.x + '% + ' + '12.5%)',
        'box-shadow': '2px 2px 5px rgba(0, 0, 0, 0.2)',
        'background-color': this.color,
        color: this.autoColor(this.color)
      }
    },
    makeIconSelect () {
      console.debug('*** Start *** makeIconSelect')
      return {
        'box-shadow': '2px 2px 5px rgba(0, 0, 0, 0.2)',
        'background-color': this.color,
        color: this.autoColor(this.color)
      }
    },
    makeBackground () {
      console.debug('*** Start *** makeBackground')
      return {
        'background-color': this.color,
        color: this.autoColor(this.color)
      }
    },
    getURL () {
      console.debug('*** Start *** getURL')
      if (this.isGetImage) return this.demoImage
      else if (this.isMobile() == false) { return require('../../assets/lp/example.png') }
      else { return require('../../assets/lp/mobile_example.jpg') }
    },
    getIcon (i) {
      console.debug('*** Start *** getIcon')
      console.debug('i: ' + JSON.stringify(i))
      return {
        'mdi mdi-message-reply mdi-24px': i === 0,
        'mdi mdi-account-location mdi-24px': i === 1,
        'mdi mdi-phone mdi-24px': i === 2,
        'mdi mdi-home-circle mdi-24px': i === 3,
        'mdi mdi-bell mdi-24px':i === 4,
        'mdi mdi-forum mdi-24px': i === 5,
        'mdi mdi-forum-outline mdi-24px': i === 6,
        'mdi mdi-comment mdi-24px': i === 7,
        'mdi mdi-comment-multiple mdi-24px': i === 8,
        'mdi mdi-comment-processing mdi-24px': i === 9
      }
    },
    nextScn () {
      console.debug('*** Start *** nextScn')
      if (this.guide >= 5) this.createPages = 3
      else this.guide++
      console.debug('*** End *** nextScn')
    },
    prevScn () {
      console.debug('*** Start *** prevScn')
      if (this.guide <= 0) this.guide = 0
      else this.guide--
      console.debug('*** End *** prevScn')
    },
    next () {
      console.debug('*** Start *** next')
      if (this.isMobile() == false) {
        console.info('not mobile')
        if (this.pages >= 4) this.pages = 1
        else this.pages++
      } else {
        console.info('mobile')
        if (this.pages >= 3) this.pages = 1
        else this.pages++
      }
      console.debug('*** Start *** next')
    },
    prev () {
      console.debug('*** Start *** prev')
      if (this.isMobile() == false) {
        console.info('not mobile')
        if (this.pages <= 1) this.pages = 4
        else this.pages--
      } else {
        console.info('mobile')
        if (this.pages <= 1) this.pages = 3
        else this.pages--
      }
      console.debug('*** End *** prev')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-container {
  background: #1B2C61;
}
.header-box {
  width: 100%;
  height: 150px;
  padding: 20px;
  padding-top: 50px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
}
.text-box {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin: 30px;
}
.detail {
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  font-weight: 600;
}
.demo-box {
  width: 100%;
  padding: 30px;
  padding-bottom: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.demo-action-box {
  width: 80%;
  max-width: 1500px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-url {
  width:50%; border-radius: 0;
}
.input-color {
  width:50px; border-radius: 0;
}
.demo-guide-view {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 5;
  display: flex; justify-content: center; align-items: center; flex-direction: column;
}
.demo-image-box {
  margin-top: 15px;
  position: relative;
  width: 100%;
  max-width: 1500px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.demo-footer {
  height: auto;
  color: white;
  margin-top: 10px;
  position: absolute;
  top: 10px;
  width: calc(80% - 35px);
  background: rgba(0, 0, 0, 0.7);
}
.demo-footer-nav {
  display: flex;
  justify-content: center;
  margin: 10px auto 5px;
}
.demo-footer-caption {
  // height: 50px;
  width: 100%;
  padding: 20px 10px;
  color: white;
  font-size: 21px;
}
$primary: #00D1B2;
$text: #D1276D;
$progress-bar-background-color: #DBDBDB;
$dummy-invert: white;
$colors: ("primary": ($primary, $dummy-invert), "link": (#209CEE, $dummy-invert), "info": (#3273DC, $dummy-invert), "success": (#23D160, $dummy-invert), "warning": (#FFDD57, $dummy-invert), "danger": (#FF3860, $dummy-invert));
.progress {
  background: $progress-bar-background-color;
  position: absolute;
  top: 0px;
  z-index: 200;
  width: 80%;
  border-radius: 0;
  max-width: 1500px;
  &::-webkit-progress-bar {
    background: transparent !important; // override bulma.css
  }
  &:indeterminate {
    animation: progress-indeterminate 1.5s linear infinite;
    background: $progress-bar-background-color linear-gradient(to right, $text 30%, $progress-bar-background-color 30%) top left / 150% 150% no-repeat;
    
    &::-moz-progress-bar {
      background: transparent !important; // override bulma.css
    }

    @each $name, $pair in $colors {
      $color: nth($pair, 1);
      &.is-#{$name} {
        background: $progress-bar-background-color linear-gradient(to right, $color 30%, $progress-bar-background-color 30%) top left / 150% 150% no-repeat;
      }
    }
  }
}

@keyframes progress-indeterminate {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.nav-button {
  display: block;
  float: left;
  height: 30px;
  overflow: hidden;
  position: relative;
  text-indent: 100%;
  white-space: nowrap;
  width: 30px;
}
.nav-button:after {
  background-color: transparent;
  border-radius: 50%;
  content: "";
  height: 10px;
  left: 50%;
  margin: -5px 0 0 -5px;
  position: absolute;
  top: 50%;
  -webkit-transition: all .2s;
  transition: all .2s;
  width: 10px;
  border: solid thin white;
}
.step-01:after {
  background-color: white;
  height: 15px;
  margin: -7.5px 0 0 -7.5px;
  width: 15px;
}
.step-02:after {
  background-color: white;
  height: 15px;
  margin: -7.5px 0 0 -7.5px;
  width: 15px;
}
.step-03:after {
  background-color: white;
  height: 15px;
  margin: -7.5px 0 0 -7.5px;
  width: 15px;
}
.step-04:after {
  background-color: white;
  height: 15px;
  margin: -7.5px 0 0 -7.5px;
  width: 15px;
}
.page-01 {
  width:  75px;
  height: 75px;
  border-radius: 50%;
  position: absolute;
  color: white;
  z-index: 20;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}
.page-02 {
  width: 40%;
  height: 70%;
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  z-index: 20;
  top: 22.5%;
  right: 30%;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}
.page-02-header {
  width: 100%;
  height: 50px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: 900;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-02-body {
  height: calc(100% - 50px);
  width: 100%;
}
.page-02-body > img {
  height: 100%;
  object-fit: cover;
}
.bot-image {
  position: absolute;
  top: 19%; left: 56%;
  height: 18.5% !important; width: 14.5%;
  background: #fdfdfd;
  z-index: 100;
}
.page-03 {
  width: 20%;
  height: 60%;
  border-radius: 5px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  z-index: 20;
  bottom: 5%;
  right: 15.5%;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
}
.page-03-header {
  width: 100%;
  height: 30px;
  border-top-left-radius:  5px;
  border-top-right-radius: 5px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-03-body {
  height: calc(100% - 30px);
  width: 100%;
}
.page-03-body > img {
  height: 100%;
  object-fit: cover;
  border-bottom-left-radius:  5px;
  border-bottom-right-radius: 5px;
}
.page-04 {
  width: 100%;
  height:100%;
  border-radius: 5px;
  position: absolute;
  border: solid 20px #000;
  z-index: 20;
  bottom: 0;
  right: 0;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3);
  background: white url('../../assets/lp/pattern.png') center center repeat repeat;
}
.bot-create-01 {
  width: 100%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.cls-btn {
  position: absolute;
  left: 25px;
  top: 25px;
  width: 100px;
  height: 30px;
  background: transparent;
  border: solid 2px white;
  color: white;
  font-size: 15px;
  cursor: pointer;
}
.bot-type {
  height: calc(60% - 30px);
  width: calc(50% - 30px);
  max-height: 200px;
  max-width: 400px;
  margin: 15px;
  padding: 10px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.scenario-box {
  height: 80%;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.scenario-editor {
  height: 100%;
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  overflow: scroll;
  border: solid 10px #323;
}
.scenario-editor::-webkit-scrollbar {
  width:  10px !important;
  height: 10px !important;
  visibility: visible !important;
}
.insert-parts-area {
  height: 100%;
  width: 20%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background: #f2f2f2;
  border: solid 10px #323;
}
.make-title {
  font-size: 24px;
  color: #1B2C61;
  font-weight: 700;
}
.make-bot-button {
  padding: 20px;
  padding-left: 40px;
  padding-right: 40px;
  border: none;
  background: #dee1e7;
  color: #1B2C61;
  font-size: 20px;
  font-weight: 700;
  border-radius: 25px;
  cursor: pointer;
  transition: 0.5s;
}
.make-bot-button:hover {
  transform: scale(1.1);
  background: #1B2C61;
  color: white;
}
.catch-copy {
  text-align: left;
  font-size: 28px;
  font-weight: 600;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.demo-image {
  border: solid 20px black;
  width: 80%;
  max-width: 1500px;
  overflow-y: scroll;
  height: auto;
}
.demo-image-loading {
  width: 80%;
  max-width: 1500px;
  height: 60vh !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
}
.next-button {
  height: 64px;
  width: 64px;
  position: absolute;
  border: none;
  top: 45%;
  right: 4%;
  background: rgba(255,255,255, 0.9);
  font-weight: 900;
  font-size: 33px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.prev-button {
  height: 64px;
  width: 64px;
  position: absolute;
  border: none;
  top: 45%;
  left: 4%;
  background: rgba(255,255,255, 0.9);
  font-weight: 900;
  font-size: 33px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.arrow, .arrow-reverse {
  height: 32px;
  width: 32px;
  object-fit: cover;
}
.arrow-reverse {
  transform: rotateZ(180deg);
}
.slider-y {
  width: calc(100% / 2.5);
  max-width: 600px;
  transform: rotate(-90deg);
  position: absolute;
  border: none;
  top: 50%;
  left: calc(80% - 10px);
  background: white;
  font-weight: 900;
  font-size: 33px;
  cursor: pointer;
  z-index: 100;
}
.slider-x {
  position: absolute;
  transform: rotateZ(180deg);
  max-width: 1500px;
  width: 75%;
  border: none;
  bottom: -40px;
  background: white;
  font-weight: 900;
  font-size: 33px;
  cursor: pointer;
  z-index: 100;
}
.color-title {
  background: white;
  border: solid thin #ccc;
  height: 36px;
  margin-left: 15px;
  padding-right: 10px;
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
}
.color-type {
  background: white;
  border: solid thin #ccc;
  height: 36px;
  margin-left: 15px;
  padding-right: 10px;
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
}

@media screen and (max-width: 900px) {
  .page-03 {
    width: 25%;
    height: 67%;
    bottom: 7%;
  }
}

@media screen and (max-width: 700px) {
  .header-box {
    height: auto;
    padding-bottom: 0;
  }
  .demo-box {
    padding-top: 0;
  }
  .demo-action-box {
    flex-wrap: wrap;
    height: auto;
  }
  .catch-copy {
    display: grid;
    text-align: center;
  }
  .catch-copy > img {
    height: 64px;
  }
  .input-url {
    width: calc(100% - 50px);
    margin-bottom: 10px;
  }
  .input-color {
    margin-bottom: 10px;
  }
  .demo-action-box > button {
    margin-bottom: 10px;
  }
  .color-title {
    width: calc(100% - 50px);
    margin-left: 0;
    margin-bottom: 10px;
  }
  .color-type {
    width: 100%;
    margin-left: 0;
  }
  .detail {
    white-space: pre-wrap;
    text-align: center;
    padding-top: 10px;
    margin-bottom: 20px;
  }
  .demo-footer {
    width: 260px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 30;
  }
  .demo-image-box {
    width: 300px;
    height: 500px;
  }
  .progress {
    width: 240px;
  }
  .demo-image {
    width: 300px;
    height: 500px;
    object-fit: cover;
  }
  .slider-y {
    width: 450px;
    left: calc(45% - 10px);
  }
  .slider-x {
    width: 250px;
  }
  .page-02 {
    width: 260px;
    height: 460px;
    top: 20px;
    right: 20px;
  }
  .bot-image {
    position: absolute;
    top: 33%; left: 40%;
    height: 48px !important; width: 48px;
    background: #fdfdfd;
    z-index: 100;
  }
  .page-03 {
    width: 260px;
    height: 460px;
    top: 20px;
    right: 20px;
  }
  .page-03-header {
    width: 100%;
    height: 50px;
    font-size: 16px;
  }
  .page-03-body {
    height: calc(100% - 50px);
    widows: 100%;
  }
  .demo-footer-caption {
    width: 100%;
    color: white;
    font-size: 13px;
  }
  .demo-footer-caption > p {
    padding-left:  10px;
    padding-right: 10px;
  }
}
@media screen and (max-width: 450px) {
  .slider-y {
    width: 450px;
    left: calc(36% - 10px);
  }
  .slider-x {
    bottom: -30px;
  }
}
/* animation */
.slide-enter-active, .slide-leave-active {
  transition: all 0.5s;
}
.slide-enter {
  opacity: 1;
  transform: translateX(100%);
}
.slide-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.slide-top-enter-active, .slide-top-leave-active {
  transition: all 0.5s;
}
.slide-top-enter {
  opacity: 1;
  transform: translateY(100%);
}
.slide-top-leave-to {
  opacity: 1;
  transform: translateY(-100%);
}
</style>



// WEBPACK FOOTER //
// src/views/Top/CompanyDemo.vue